import I18n from 'I18n';
import styled from 'styled-components';
import TimelineItemIcon from 'flow-doctor-lib/components/timeline/TimelineItemIcon';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { SuccessIcon } from 'foundations-assets';
import TimelineItemStepLabel from 'flow-doctor-lib/components/timeline/labels/TimelineItemStepLabel';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import Small from 'UIComponents/elements/Small';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { TIMESTAMP_FORMAT } from 'flow-doctor-lib/constants/Global';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BoxOutline = styled.div.withConfig({
  displayName: "SelectableEnrollmentTimelineItem__BoxOutline",
  componentId: "sc-1w79gfs-0"
})(({
  theme
}) => `
  border: solid ${theme.color['border-core-default']};
  border-radius: ${theme.borderRadius['100']};
  border-width: ${theme.borderWidth['25']};
  padding: ${theme.space['400']};
`);
const DEFAULT_PROPS_FOR_ICON = {
  backgroundColor: 'fill-primary-default',
  borderStyle: 'solid',
  borderWidth: '200',
  color: 'icon-core-subtle',
  icon: SuccessIcon,
  padding: '100',
  size: '200'
};
const SelectableEnrollmentTimelineItem = ({
  flowId,
  objectTypeId,
  logItem,
  onClick
}) => {
  const hideTestButton = logItem.type === 'ENROLLMENT_LOG_EVENT' && !!['ENROLLMENT', 'UNENROLLMENT'].includes(logItem.data.type);
  return /*#__PURE__*/_jsx(BoxOutline, {
    "data-test-id": `timeline-${logItem.type}`,
    children: /*#__PURE__*/_jsxs(UIFlex, {
      gap: 16,
      justify: "start",
      children: [/*#__PURE__*/_jsx(UIBox, {
        children: /*#__PURE__*/_jsx(TimelineItemIcon, {
          size: "200",
          logItem: logItem,
          defaultIcon: /*#__PURE__*/_jsx(IconCircle, Object.assign({}, DEFAULT_PROPS_FOR_ICON))
        })
      }), /*#__PURE__*/_jsxs(UIBox, {
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            textTransform: 'initial'
          },
          children: /*#__PURE__*/_jsx(TimelineItemStepLabel, {
            flowId: flowId,
            logItem: logItem,
            objectTypeId: objectTypeId
          })
        }), /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: I18n.moment.portalTz(logItem.timestamp),
            format: TIMESTAMP_FORMAT
          })
        })]
      }), onClick && !hideTestButton && /*#__PURE__*/_jsx(UIBox, {
        alignSelf: "center",
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary-light",
          size: "small",
          onClick: onClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.objectLifecycle.testEnrollmentEvent"
          })
        })
      })]
    })
  });
};
export default SelectableEnrollmentTimelineItem;